import React from 'react';
import { Button, Text, View } from "../../Components/Themed"
import type { CampaignParticipantProps, PublicPlayerProps } from "../../types"
import { Icons } from '../../Components';
import { useColors } from '../../constants/useColors';
import moment from 'moment-mini';
import { Image } from 'react-native';
import ProgressTimer from './ProgressTimer';
import QRCode from 'react-qr-code';

type NewPlayerAlertProps = {
    view_mode:'desktop'|'mobile',
    player:PublicPlayerProps,
    campaign_participant:CampaignParticipantProps,
    onViewProfile?:(player:PublicPlayerProps) => void
    onClose:() => void
}

const NewPlayerAlert = ({ player, view_mode, campaign_participant, onClose, onViewProfile }:NewPlayerAlertProps) => {
    const Colors = useColors();
    return (
        <View float style={{ width:350 }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:18, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                <Icons.BettorEdgeIcon size={18} color={Colors.text.h1} />
                <View transparent style={{ flex:1, marginLeft:20, marginRight:10 }}>
                    <Text theme='h1'>NEW PLAYER ALERT!</Text>
                    <Text theme='description' style={{ marginTop:5 }}>@{player?.username}  {`\u2022`} First Checked In {moment(campaign_participant.create_datetime).fromNow()}</Text>
                </View>
            </View>
            <View type='body'>
                <Image
                    source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:200, width:350 }}
                    resizeMode='cover'
                />
                <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>    
                    <View transparent style={{ flex:1, marginLeft:10 }}>
                        <Text theme='h1'>@{player.username}</Text>
                        <Text style={{ marginTop:3 }} theme='description'>Joined BettorEdge {moment(player.create_datetime).fromNow()}</Text>
                    </View>
                </View>
                {view_mode == 'desktop' ?
                <View type='header' style={{alignItems:'center', padding:10}}>
                    <QRCode
                        size={100}
                        value={`https://play.bettoredge.com/social/player/${campaign_participant.player_id}`}
                    />
                    <Text textAlign='center' theme='h2' style={{ marginTop:4 }}>CHECK OUT MY PROFILE</Text>
                </View>
                :<></>}
            </View>
            <View type='footer' style={{ borderBottomRightRadius:view_mode == 'desktop' ? 8: 0, borderBottomLeftRadius:view_mode == 'desktop'?8:0 }}>
                <ProgressTimer
                    onTimesUp={() => onClose()}
                    time_id={campaign_participant.campaign_participant_id.toString()}
                    total_time={15}
                />
            </View>
            {view_mode == 'mobile' ?
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', borderBottomRightRadius:8, borderBottomLeftRadius:8, padding:10 }}>
                {onViewProfile ?
                <Button
                    title='View Profile'
                    type='success'
                    style={{ flex:1, marginRight:3 }}
                    onPress={() => onViewProfile(player)}
                />
                :<></>}
                <Button
                    title='CLOSE'
                    type='error'
                    style={{ flex:1, marginLeft:3 }}
                    onPress={() => onClose()}
                />
            </View>
            :<></>}
        </View>
    )
}

export default NewPlayerAlert